<template>
  <div class="instrumentTime">
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="时间">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="职级">
          <el-input v-model.trim="filters.positionRank" clearable></el-input>
        </el-form-item>
        <el-form-item label="身份">
          <el-input v-model.trim="filters.identity" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="buttonText">
        <el-button type="warning" @click="add" icon="el-icon-plus">新增</el-button>
        <el-button type="danger" @click="delAll" icon="el-icon-delete">批量删除</el-button>
        <!-- <div class="delete" @click="delAll">批量删除</div>
        <div class="addData" @click="add">新增</div> -->
      </div>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
        <el-table-column sortable prop="identity" label="身份"></el-table-column>
        <el-table-column sortable prop="positionRank" label="职级"></el-table-column>
        <el-table-column sortable prop="amt" label="金额"></el-table-column>
        <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
        <el-table-column sortable prop="createTime" label="添加时间"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增编辑身份弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="身份">
          <el-input v-model.trim="formData.identity" placeholder="请输入身份名称" style="width:95%;"></el-input>
        </el-form-item>
        <div class="flex" v-for="(domain, index) in formData.identityRankMenuList" :key="index">
          <el-form-item label="职级">
            <el-input v-model.trim="domain.positionRank" placeholder="请输入职级"></el-input>
          </el-form-item>
          <el-form-item label="金额">
            <el-input v-model.trim="domain.amt" placeholder="请输入职级"></el-input>
          </el-form-item>
          <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(domain,index)" v-show="index > 0">
            <i class="el-icon-delete"></i>
          </el-button>
        </div>
        <el-form-item>
          <el-button @click="editAddDomain" type="primary" size="mini">添加职级</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "class",
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      formData: {
        identityRankMenuList: [
          {
            positionRank: '',
            amt: "",
          }
        ]
      },
      tableHeight: '',
      isId: '',
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 380
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    },
  },
  methods: {
    // 编辑时新增部位
    editAddDomain(index) {
      this.formData.identityRankMenuList.push({
        key: Date.now(),
        positionRank: '',
        amt: "",
      });
    },
    // 编辑时删除部位
    editRemoveDomain(item, listIndex) {
      var index = this.formData.identityRankMenuList.indexOf(item)
      if (index !== -1) {
        this.formData.identityRankMenuList.splice(listIndex, 1)
      }
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },

    handleEdit(index, row) {
      this.dialogFormVisible = true
      this.formData.disabled = true
      this.isId = row.id
      api.requestQuiet("/identity/findIdentityRankMenuById", { id: row.id }, (res) => {
        this.formData = res.data
      }, (err) => { });
    },
    // 新增项目
    add() {
      this.isId = ''
      this.dialogFormVisible = true
      // 新增置空
      this.formData = {
        identityRankMenuList: [
          {
            positionRank: '',
            amt: "",
          }
        ]
      }
    },
    doAddgoods() {
      this.formData.createBy = Lockr.get('skinEmpId')
      if (this.isId) {
        api.requestQuiet("/identity/updateIdentityRankMenu", this.formData, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", '修改成功');
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", res.errMsg);
          }
        }, (err) => { });
      } else if (!this.isId) {
        api.requestQuiet("/identity/createIdentityRankMenu", this.formData, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", '添加成功');
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", res.errMsg);
          }
        }, (err) => { });
      }
    },
    // 删除项目
    del(index, row) {
      this.$confirm('确定要该条数据吗？', '删除项目', {
        center: true
      })
        .then((res) => {
          api.request("/identity/deleteIdentityRankById", {
            id: row.id
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })
    },
    // 批量删除
    delAll() {
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        console.log(item)
        id.push(item.id);
      });
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet(
            "/identity/deleteIdentityRankAll", {
              idList: id.toString(),
            },
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        identity: this.filters.identity,
        startTime: '',
        endTime: '',
        page: page,
        size: this.filters.pagination.limit,
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.request('/identity/findIdentityRankPage', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.filters.pagination.total = parseInt(res.data.count)
      })
    },
  },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
</style>